import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {Progress} from "@careers-wales/react-components";

function DecisionProgress(props) {
    const { t } = useTranslation();
    let steps = [];

    props.questions.questions.forEach((item,index) => {

        steps.push({
            title: item.pageTitle,
            isComplete: props.stage > index ,
            isCurrent: props.stage === index ,
            isDisabled: props.stage < index,
            onPress: () => {
                props.setCurrentStage(index)
            }
        })
    })

    // Add in the result page.
    steps.push({
        title: t('view.results.style.title'),
        isComplete: props.stage > props.questions.questions.length ,
        isCurrent: props.stage === props.questions.questions.length ,
        isDisabled: props.stage < props.questions.questions.length,

    })

    return (
        <Progress steps={steps}></Progress>
    );
}

export default DecisionProgress;
